<template>
  <div>
    <loading :active.sync="isLoading" opacity="0.9"></loading>

    <div class="row">
      <div class="col-md-12">

        <KTCodePreview class="px-10" v-bind:title="$t('KYBActivityLog')">

          <template v-slot:preview>
            <b-row>
              <b-col cols="5">
              </b-col>
              <b-col>
                <b-input-group class="mb-3 pr-0">
                  <b-form-input
                      readonly
                      style="width: 120px;"
                      id="fromdate-input"
                      v-model="fromDate"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off">
                  </b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                        :max="toDateYYMMDD"
                        v-model="fromDate"
                        button-only
                        right
                        locale="en-US"
                        aria-controls="fromdate-input"
                        @context="onContextFrom"
                    ></b-form-datepicker>
                  </b-input-group-append>
                  <span class="mx-1">~</span>
                  <b-form-input
                      readonly
                      style="width: 120px;"
                      id="todate-input"
                      v-model="toDate"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                        :max="toDateYYMMDD"
                        v-model="toDate"
                        button-only
                        right
                        locale="en-US"
                        aria-controls="todate-input"
                        @context="onContextTo"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
<!--
              <b-col cols="2">
                <b-button variant="outline-primary" style="min-width:100px;" class="ml-1" :disabled="!fromDate && !toDate"
                          @click="searchData()">
                  <b-icon-search font-scale="0.9"/>
                  search
                </b-button>
              </b-col>
-->


            </b-row>


            <div class="p-3 mb-5 text-center" v-if="activityHistoriesFiltered.length==0">
              {{$t("NoData") }}

            </div>

            <div v-if="activityHistoriesFiltered.length > 0">

              <template>
                <v-data-table
                    :headers="activityColumn"
                    :items="activityHistoriesFiltered"
                    :page.sync="currentPage"
                    :items-per-page="10"
                    hide-default-footer
                >
                  <template v-slot:item.createTime="{ item }">
                    <span>{{item.createTime | datetimeFormatSecond }}</span>
                  </template>

                </v-data-table>

                <b-pagination class="my-5" v-model="currentPage" :total-rows="totalCount" :per-page="10" align="center"></b-pagination>
              </template>

              <!--
              <div class="my-10">
                <div class="text-center pt-2">
                  <v-pagination
                      v-model="page"
                      :length="pageCount"
                  ></v-pagination>
                </div>
              </div>
              -->

            </div>

          </template>



        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";


export default {
  name: "ActionHistory",
  components: {
    KTCodePreview,
  },
  data() {
    return {

      totalCount : 0,
      currentPage : 1,
      isLoading: false,
      toDateYYMMDD : "",

      /**
       * 검색관련
       */
      fromDate : "",
      toDate : "",

      project_id : "",
      currentPageSubmissionList : [],

      page: 1,
      pageCount: 0,

      activityColumn : [
        { text : this.$t("KYBApplicantName"), value: "companyName"},
        { text : this.$t("KYBSubmissionId"), value: "submissionId"},
        { text : this.$t("Event"), value: "eventTrigger"},
        { text : this.$t("Description"), value: "description"},
        { text : this.$t("CreatedAt"), value: "createTime"},
      ],
      activityHistories : [
        /*
        {
          "admin_name": "",
          "companyName": "USEON_YEOM",
          "createTime": "2021-05-31T05:53:56.290Z",
          "eventTrigger": "New Shareholder",
          "description": "(Test Name2) Shareholder Created!!",
          "project_id": "1c807f1b656bec93b7869ea785ea703d",
          "submissionId": "1igvu9kpc6q5ey",
          "uniq_no": "dc0b1e6f-b326-425d-bd98-53323cc78cc2"
        }
        */
      ],

    }
  },

  computed : {

    activityHistoriesFiltered () {

      let fromDate = new Date( this.fromDate );
      let toDate = this.$addDay( this.toDate, 1 );
      const result = this.activityHistories.filter( function( item ) {
        let createDate = new Date( item.createTime );
        return (
            createDate >= fromDate &&
                createDate < toDate
        );
      } );

      return result;
    }
  },

  methods : {

    searchData () {

      this.getList();

    },
    onContextFrom(ctx) {
      if( new Date( ctx.selectedYMD ) < new Date( this.fromDate ) ) {
        this.fromDate = this.lastYearDateYYMMDD;
        this.toDate = this.toDateYYMMDD;
        return;
      }
      this.fromDate = ctx.selectedYMD;
    },

    onContextTo(ctx) {

      if( new Date( ctx.selectedYMD ) < new Date( this.fromDate ) ) {
        this.toDate = this.toDateYYMMDD;
        return;
      }
      this.toDate = ctx.selectedYMD;
    },
    /*
    convertDateFormat(date){
      if(date.indexOf(' ') > -1){
        let newDate = new Date(date.split(' ')[0]).toString();
        let dateArr = newDate.split(' ');
        return dateArr[3] + '. ' + dateArr[1] + ' ' + dateArr[2] + ' ' + date.split(' ')[1];
      }else{
        let newDate = new Date(date).toString();
        let dateArr = newDate.split(' ');
        return dateArr[3] + '. ' + dateArr[1] + ' ' + dateArr[2];
      }
    },*/

    async getList () {

      this.isLoading = true;

      let param = {
        projectId : this.$store.getters.getSelectedProjectId
      }
      param.startDate = this.fromDate;
      param.endDate = this.$moment(new Date(this.toDate)).add('days', 1).format('YYYY-MM-DD');


      console.log( "getHistory param ::: ", param );
      try {
        let returnValue = await this.$store.dispatch('getKybEventLog', param) || [];
        let resultArr = returnValue.Items || [];
        this.totalCount = resultArr.length;
        this.activityHistories = this.$sortByDate( resultArr );
      }
      catch( e ) {
        console.log( "get activity history error ::: ", e );
      }
      finally {
        this.isLoading = false;
      }
    },
  },

  async mounted () {

    await this.$store.dispatch(SET_BREADCRUMB, [
      /*
                { title: "Vuetify", route: "alerts" },
                { title: "Tables", route: "simple-tables" },
                */
      { title: "KYB Activity Log" }
    ]);

    let today = new Date();
    let lastYear = this.$addYear( today, -1 );

    this.fromDate = this.$moment( lastYear ).format('YYYY-MM-DD');
    let todayFormat = this.$moment(today).format('YYYY-MM-DD');
    this.toDate = todayFormat;
    this.toDateYYMMDD = todayFormat;

    await this.getList();

  },
  watch : {
    "$i18n.locale": {
      handler() {
        this.activityColumn = [
          { text : this.$t("KYBApplicantName"), value: "companyName"},
          { text : this.$t("KYBSubmissionId"), value: "submissionId"},
          { text : this.$t("Event"), value: "eventTrigger"},
          { text : this.$t("Description"), value: "description"},
          { text : this.$t("CreatedAt"), value: "createTime"},
        ]
      },
    }
  }
};
</script>

<style scoped>

</style>
